<template>
  <Upload></Upload>
</template>
<script>
import Upload from '@/components/material-video-upload';

export default {
  name: '',
  components: {
    Upload,
  },
};
</script>
